import React, { useEffect } from 'react'
import { CountMetric } from '@amzn/ihm-associate-tools-js-lib'
import { useBundle } from '@amzn/react-arb-tools'
import { getStoreId } from '@src/utils/EnvironmentUtil'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import './HomePage.css'

const HomePage: React.FC = () => {
    const [bundle] = useBundle(BUNDLE_NAME)

    // Emit a load metric on mount so we can track at runtime whether this static
    // home page actually renders. Uses the same CountMetric path as the rest of
    // the platform (e.g. IFrameController's ToolLoaded) — broadcastMetric() is
    // routed to CloudWatch by the MetricInterceptor mounted in App. The operation
    // is 'HomePage' to distinguish it from iframe ToolLoaded metrics.
    useEffect(() => {
        const storeId = getStoreId()
        new CountMetric(storeId || undefined, 'ToolLoaded', 'JWOStoreManagementPlatform', 'HomePage').count(1)
    }, [])

    return (
        <div className="portal-page-content" data-atb-id="home-page">
            <div className="home-container">
                <h2 className="home-title">{t(bundle, 'jsma-web-home-title')}</h2>
                <span className="home-subtitle">{t(bundle, 'jsma-web-home-pilotRelease')}</span>
                <p className="home-description">
                    {t(bundle, 'jsma-web-home-descriptionPilot')}
                </p>
                <p className="home-description">
                    {t(bundle, 'jsma-web-home-descriptionFeedback')}
                </p>
                <img src={require('@src/assets/jwo-logo-light.png')} alt={t(bundle, 'jsma-web-common-jwoLogoAlt')} className="home-logo" />
            </div>
        </div>
    )
}

export default HomePage
